var APP_ID = 'appOhr2UrV8PZ3fQH';
var API_KEY = 'pat6xUXpfRTWIUKmo.5c2cd2382f29c08688420972a1e2c9f5a5adc598d8e4c9278ac6db472706c7b1';
var SORT = "sort%5B0%5D%5Bfield%5D=Name&sort%5B0%5D%5Bdirection%5D=asc";
var TITLE = document.title;

var Home = {
  props: ['worldMap'],

  data: function () {
    return {
      origins: [],
      loading: true
    }
  },

  template: ' \
	<div> \
	  <header class="page-masthead"> \
        <h1 class="page-title">The World of Shawnimals</h1> \
<div style="width: 85%; margin: 0 auto;"><p>The world of Shawnimals is vast! Over 20 different lands, chock full of different creatures and characters — over 450 of them, in fact! Explore and enjoy the silly awesomeness for as long as you\'d like. Better yet, get lost and let your imagination run wild...</p></div> \
		<img id="worldMap" :src="worldMap" usemap="#m_051812_shawnimaland_hotspot"> \
  	  </header> \
      <section class="product-row--container"> \
        <div class="product-row"> \
          <article class="productgrid--item" v-for="origin in origins"> \
            <div class="productitem"> \
              <router-link class="productitem--image-link" :to="{ name: \'origin\', params: { slug: origin.fields.Slug } }"> \
                <figure class="productitem--image"> \
                  <img :src="origin.fields.Image[0].url" :alt="origin.fields.Name"> \
                </figure> \
              </router-link> \
              <div class="productitem--info"> \
                <h2 class="productitem--title"> \
                  <router-link :to="{ name: \'origin\', params: { slug: origin.fields.Slug } }"> \
                    {{ origin.fields.Name }} \
                  </router-link> \
                </h2> \
              </div> \
          </article> \
        </div> \
      </section> \
	  <div class="lds-ring" v-if="loading"><div></div><div></div><div></div><div></div></div> \
    </div>',

  mounted: function () {
    var self = this;

    axios.get("https://api.airtable.com/v0/" + APP_ID + "/Origins?" + SORT, {
      headers: {
        Authorization: "Bearer " + API_KEY
      },
    }).then(function (response) {
      self.origins = response.data.records;
      self.loading = false;
      document.title = TITLE;
    }).catch(function (error) {
      console.log(error);
    });
  }
}

var Origin = {
  data: function () {
    return {
      characters: [],
      loading: true
    }
  },

  computed: {
    originName: function () {
      return this.characters[0] ? this.characters[0].fields.OriginName[0] : '';
    },
    
    originDescription: function () {
      return this.characters[0] ? this.characters[0].fields.OriginDescription[0] : '';
    },
    
    originImage: function () {
      return this.characters[0] ? this.characters[0].fields.OriginImage[0].url : '';
    },
  },

  template: ' \
    <div> \
      <nav class="breadcrumbs-container" aria-label="Breadcrumbs"> \
        <a href="/pages/the-world-of-shawnimals">Worlds</a> \
        <span class="breadcrumbs-delimiter" aria-hidden="true"> \
          <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"> \
          <path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"></path> \
          </svg> \
        </span> \
        <span>{{ originName }}</span> \
      </nav> \
	  <section class="product-info layout--three-col"> \
        <div class="product-gallery"> \
		  <img :src="originImage" :alt="originName"> \
        </div> \
        <div class="product-main"> \
          <div class="product-details"> \
            <h1 class="product-title">{{ originName }}</h1> \
          </div> \
          <div class="product-description" v-html="originDescription"></div> \
        </div> \
      </section> \
      <section class="product-row--container"> \
        <div class="product-row"> \
          <article class="productgrid--item" v-for="character in characters"> \
            <div class="productitem"> \
              <router-link class="productitem--image-link" :to="{ name: \'character\', params: { slug: character.fields.Slug, id: character.id } }"> \
                <figure class="productitem--image"> \
                  <img :src="character.fields.Image[0].url" :alt="character.fields.Name"> \
                </figure> \
              </router-link> \
              <div class="productitem--info"> \
                <h2 class="productitem--title"> \
                  <router-link :to="{ name: \'character\', params: { slug: character.fields.Slug, id: character.id } }"> \
                    {{ character.fields.Name }} \
                  </router-link> \
                </h2> \
                Created: {{ character.fields.YearCreated }} \
              </div> \
          </article> \
        </div> \
      </section> \
      <div class="lds-ring" v-if="loading"><div></div><div></div><div></div><div></div></div> \
    </div>',

  mounted: function () {
    var self = this;

    axios.get("https://api.airtable.com/v0/" + APP_ID + "/Characters?" + SORT, {
      headers: {
        Authorization: "Bearer " + API_KEY
      },

      params: {
        filterByFormula: "({OriginSlug} = \"" + this.$route.params.slug + "\")"
      }
    }).then(function (response) {
      self.characters = response.data.records;
      self.loading = false;
      document.title = "The Creatures of " + self.originName + " - " + TITLE;
    }).catch(function (error) {
      console.log(error);
    });
  }
}

var Character = {
  data: function () {
    return {
      character: {},
      loading: true
    }
  },

  computed: {
    characterName: function () {
      return this.character.fields ? this.character.fields.Name : '';
    },
    
    characterImage: function () {
      return this.character.fields ? this.character.fields.Image[0].url : '';
    },
    
    characterDescription: function () {
      return this.character.fields ? this.character.fields.Description : '';
    },
    
    characterYear: function () {
      return this.character.fields ? this.character.fields.YearCreated : '';
    },
    
    characterBuy: function () {
      return this.character.fields &&
        this.character.fields.Available &&
        this.character.fields.PurchaseURL;
    },
    
    originName: function () {
      return this.character.fields ? this.character.fields.OriginName[0] : '';
    },
    
    originSlug: function () {
      return this.character.fields ? this.character.fields.OriginSlug[0] : '';
    },
  },

  template: ' \
	<div> \
      <nav class="breadcrumbs-container" aria-label="Breadcrumbs"> \
        <a href="/pages/the-world-of-shawnimals">Worlds</a> \
        <span class="breadcrumbs-delimiter" aria-hidden="true"> \
          <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"> \
          <path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"></path> \
          </svg> \
        </span> \
        <router-link :to="{ name: \'origin\', params: { slug: originSlug } }">{{ originName }}</router-link> \
        <span class="breadcrumbs-delimiter" aria-hidden="true"> \
          <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"> \
          <path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"></path> \
          </svg> \
        </span> \
        <span>{{ characterName }}</span> \
      </nav> \
	  <section class="product-info layout--three-col" v-if="!loading"> \
        <div class="product-gallery"> \
		  <img :src="characterImage" :alt="characterName"> \
        </div> \
        <div class="product-main"> \
          <div class="product-details"> \
            <h1 class="product-title">{{ characterName }}</h1> \
          </div> \
          <div class="product-description" v-html="characterDescription"></div> \
          <ul class="product-meta"> \
			<li><strong>Origin:</strong> <router-link :to="{ name: \'origin\', params: { slug: originSlug } }">{{ originName }}</router-link></li> \
       		<li v-if="characterYear"><strong>Created:</strong> {{characterYear}}</li> \
		  </ul> \
          <p v-if="characterBuy"> \
            <a :href="characterBuy" class="button-primary"> \
              View Products \
            </a> \
          </p> \
        </div> \
      </section> \
	  <div class="lds-ring" v-if="loading"><div></div><div></div><div></div><div></div></div> \
    </div>',
      
  mounted: function () {
    var self = this;
    var characterId = this.$route.params.id;

    axios.get("https://api.airtable.com/v0/" + APP_ID + "/Characters/" + characterId, {
      headers: {
        Authorization: "Bearer " + API_KEY
      },
    }).then(function (response) {
      self.character = response.data;
      self.loading = false;
      document.title = self.characterName + " - " + TITLE;
    }).catch(function (error) {
      console.log(error);
    });
  }
}

var routes = [
  { path: "/", name: 'home', component: Home, props: true },
  { path: "/origins/:slug", name: 'origin', component: Origin },
  { path: "/characters/:slug/:id", name: 'character', component: Character }
];

var app = new Vue({
  el: '#world',
  router: new VueRouter({
    routes: routes,
    scrollBehavior: function (to, from, savedPosition) {
      if (savedPosition) return savedPosition;
      
      let selector = "#top"
      let el = document.querySelector(selector)
      let rect = el.getBoundingClientRect()

      if ( rect.top + document.body.scrollTop < 0 ) {
        return { selector: selector }
      }
    }
  }),
});